import React, { useState } from 'react';
import BreadcrumbBack from '../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../components/button/CustomButton';
import { useLocation, useNavigate } from 'react-router-dom';
import PaginationDataGrid from '../../../components/tables/PaginationDataGrid';
import TableButton from '../../../components/button/TableButton';
import { generateRandomString } from '../../../helpers/commonHelper';
import { CSVDownload } from '../../../helpers/FileDownloader';
import Models from '../../../components/models/Models';
import ExcelUpload from '../../../components/uploads/ExcelUpload';
import {
  getAllCenterStudents,
  getFreeCenterStudents,
  getPaidCenterStudents,
  bulkDeleteStudentsByEmails,
} from '../../../service/admin/adminStudent.service';
import moment from 'moment';
import { toast } from 'react-toastify';
import AdminStudentCE from './AdminStudentCE';
import { Helmet } from 'react-helmet-async';
import Swal from 'sweetalert2';

export default function AdminStudents() {
  const [openUpload, setOpenUpload] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [bulkDeleteOpen, setBulkDeleteOpen] = useState(false);
  const [bulkDeleteEmails, setBulkDeleteEmails] = useState('');
  const [bulkDeleteLoading, setBulkDeleteLoading] = useState(false);
  const [bulkDeleteResult, setBulkDeleteResult] = useState<{
    deletedStudents?: { id: string; name: string; email: string }[];
    notFoundEmails?: string[];
    deletedCount?: number;
  } | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const navigate = useNavigate();
  const [activetab, setActiveTab] = useState({
    id: 0,
    name: 'All Students',
    title: 'AdminAllStudents',
  });
  const tablist = [
    { id: 0, name: 'All Students', title: 'AdminAllStudents' },
    { id: 1, name: 'Paid Students', title: 'AdminPaidStudents' },
    { id: 2, name: 'Free Students', title: 'AdminFreeStudents' },
  ];

  const handleBulkDeleteOpen = () => {
    setBulkDeleteEmails('');
    setBulkDeleteResult(null);
    setBulkDeleteOpen(true);
  };

  const handleBulkDelete = async () => {
    if (!bulkDeleteEmails.trim()) {
      return toast.error('Please enter at least one email address');
    }
    
    const confirmResult = await Swal.fire({
      title: 'Confirm Deletion',
      html: `<p>Are you sure you want to delete students with these emails?</p><p style="color: red; font-weight: bold;">This action cannot be undone!</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
    });
    
    if (!confirmResult.isConfirmed) return;

    setBulkDeleteLoading(true);
    try {
      const result = await bulkDeleteStudentsByEmails(bulkDeleteEmails.trim());
      if (result?.status === 'success') {
        toast.success(result.message || 'Students deleted successfully');
        setBulkDeleteResult({
          deletedStudents: result.deletedStudents,
          notFoundEmails: result.notFoundEmails,
          deletedCount: result.deletedCount,
        });
        setBulkDeleteEmails('');
        // Refresh the data grids
        setRefreshKey(prev => prev + 1);
      } else {
        toast.error(result?.message || 'Failed to delete students');
      }
    } catch (error) {
      toast.error('An error occurred while deleting students');
    } finally {
      setBulkDeleteLoading(false);
    }
  }
  const handleDownload = async (e: any) => {
    let get: any;
    if (e === 'all') {
      get = await getAllCenterStudents();
    } else if (e === 'paid') {
      get = await getPaidCenterStudents();
    } else if (e === 'free') {
      get = await getFreeCenterStudents();
    }
    if (get?.status === 'success') {
      if (get?.message.length > 0) {
        let newData: any = [];
        get?.message.map((e: any, i: number) => {
          newData.push({
            'S No': i + 1,
            Name: e.name,
            Email: e.email,
            Phone: e.phone,
            DOB: moment(e.dob).format('YYYY-MM-DD'),
            Gender: e?.gender?.name,
          });
        });
        CSVDownload(`${e} students`, newData);
      } else {
        return toast.error('No students found for download');
      }
    }
  };
  const handleFileUpload = async () => {
    setOpenUpload(!openUpload);
  };
  const handleSampleDownload = async () => {
    let data = [];
    for (let i = 0; i <= 1; i++) {
      data.push({
        S_no: i + 1,
        Name: i + 'Sample User',
        Phone: generateRandomString(10, true),
        Email: generateRandomString(3, true) + 'sample@demo.in',
        DOB: '2002-12-12',
        Gender: 'Male',
      });
    }
    CSVDownload('student-sample-download', data);
  };
  return (
    <>
      <Helmet>
        <title>{` Students    | ${window.location.hostname}`}</title>
      </Helmet>
      <BreadcrumbBack title="Students">
        <CustomButton
          onClick={() => setOpen(!open)}
          title="Create New Student"
          icon={true}
          iconName="create"
        />
      </BreadcrumbBack>
      <div className="my-2">
        <div className="">
          <div className=" ">
            {tablist?.length > 0 ? (
              <>
                <div className="flex flex-row gap-2 items-center justify-between">
                  <div className="flex flex-row gap-4 items-center ">
                    {tablist.map((e: any) => (
                      <>
                        <button
                          onClick={() => setActiveTab(e)}
                          className={`${activetab.id === e.id ? 'hover-purple-gradient text-white' : 'bg-gray-200 dark:bg-secondary'} p-2 font-semibold rounded-md hover:shadow-xl`}
                        >
                          {e.name}
                        </button>
                      </>
                    ))}
                  </div>
                  <div className="gap-2 flex flex-row  flex-wrap justify-end mr-5  ">
                    <TableButton
                      onClick={() => setDownloadOpen(!downloadOpen)}
                      icon={true}
                      title="download"
                      text="Download Students"
                      toottip="Download Excel"
                    />
                    <TableButton
                      onClick={handleFileUpload}
                      text="Upload Students"
                      icon={true}
                      title="upload"
                      toottip="Upload Excel"
                    />
                    <TableButton
                      onClick={handleSampleDownload}
                      text="Download Sample"
                      icon={true}
                      title="excel"
                      toottip="Download Sample Excel"
                    />
                     <TableButton
                      onClick={handleBulkDeleteOpen}
                      text="Bulk Delete"
                      icon={true}
                      title="delete"
                      toottip="Bulk Delete Students by Email"
                    />
                  </div>
                </div>

                {activetab.id === 0 ? (
                  <div className="mt-2">
                    <PaginationDataGrid key={`all-${refreshKey}`} name="AdminAllStudents" />
                  </div>
                ) : null}
                {activetab.id === 1 ? (
                  <div className="mt-2">
                    <PaginationDataGrid key={`paid-${refreshKey}`} name="AdminPaidStudents" />
                  </div>
                ) : null}
                {activetab.id === 2 ? (
                  <div className="mt-2">
                    <PaginationDataGrid key={`free-${refreshKey}`} name="AdminFreeStudents" />
                  </div>
                ) : null}
              </>
            ) : null}
          </div>
        </div>
      </div>
      <Models name="Create New Student " isOpen={open} isClose={setOpen}>
        <AdminStudentCE type="create" isOpen={setOpen} />
      </Models>
      <div className="lg:w-[60vw]">
        <Models
          name="Upload Batch Student"
          isOpen={openUpload}
          isClose={setOpenUpload}
        >
          <ExcelUpload
            name="AdminStudentUpload"
            accept=".csv"
            open={setOpenUpload}
          />
        </Models>
      </div>
      <Models
        name="Download Students"
        isOpen={downloadOpen}
        isClose={setDownloadOpen}
      >
        <div className="flex flex-col my-1 gap-3">
          <TableButton
            onClick={() => handleDownload('all')}
            bg={`border-[#7516c8] hover:bg-[#5c07a7] bg-[#7516c8] text-white`}
            icon={true}
            title="download"
            text="Download All Students"
            toottip="Download All Students"
          />
          <TableButton
            onClick={() => handleDownload('paid')}
            bg={`border-[#650469] hover:bg-[#4d0450] bg-[#650469] text-white`}
            icon={true}
            title="download"
            text="Download Paid Students"
            toottip="Download Paid Students"
          />
          <TableButton
            onClick={() => handleDownload('free')}
            bg={`border-[#141191] hover:bg-[#0f0c73] bg-[#141191] text-white`}
            icon={true}
            title="download"
            text="Download Free Students"
            toottip="Download Free Students"
          />
        </div>
      </Models>
      <Models
        name="Bulk Delete Students"
        isOpen={bulkDeleteOpen}
        isClose={setBulkDeleteOpen}
      >
        <div className="flex flex-col gap-4 p-2">
          <div className="text-sm text-gray-600 dark:text-gray-300">
            Enter student email addresses separated by commas to delete them in bulk.
          </div>
          <textarea
            className="w-full h-32 p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent dark:bg-gray-800 dark:text-white resize-none"
            placeholder="Enter emails separated by commas, e.g: student1@demo.com, student2@demo.com"
            value={bulkDeleteEmails}
            onChange={(e) => setBulkDeleteEmails(e.target.value)}
            disabled={bulkDeleteLoading}
          />
          <button
            onClick={handleBulkDelete}
            disabled={bulkDeleteLoading || !bulkDeleteEmails.trim()}
            className={`w-full py-3 px-4 rounded-lg font-semibold text-white transition-all duration-200 ${
              bulkDeleteLoading || !bulkDeleteEmails.trim()
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-red-600 hover:bg-red-700 hover:shadow-lg'
            }`}
          >
            {bulkDeleteLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
                Deleting...
              </span>
            ) : (
              'Delete Students'
            )}
          </button>

          {bulkDeleteResult && (
            <div className="mt-2 space-y-3">
              {bulkDeleteResult.deletedCount && bulkDeleteResult.deletedCount > 0 && (
                <div className="p-3 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
                  <h4 className="font-semibold text-green-700 dark:text-green-400 mb-2">
                    ✓ Deleted {bulkDeleteResult.deletedCount} Student(s)
                  </h4>
                  <ul className="text-sm text-green-600 dark:text-green-300 space-y-1">
                    {bulkDeleteResult.deletedStudents?.map((student, index) => (
                      <li key={index} className="flex gap-2">
                        <span className="font-medium">{student.name}</span>
                        <span className="text-green-500">({student.email})</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {bulkDeleteResult.notFoundEmails && bulkDeleteResult.notFoundEmails.length > 0 && (
                <div className="p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg border border-yellow-200 dark:border-yellow-800">
                  <h4 className="font-semibold text-yellow-700 dark:text-yellow-400 mb-2">
                    ⚠ Not Found Emails
                  </h4>
                  <ul className="text-sm text-yellow-600 dark:text-yellow-300 space-y-1">
                    {bulkDeleteResult.notFoundEmails.map((email, index) => (
                      <li key={index}>{email}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </Models>
    </>
  );
}
